import React, { Component } from 'react';
import { Container } from 'react-bootstrap';

export default class FooterHome extends Component {
  render() {
    return (
      <Container fluid style={{ paddingLeft: '0px', paddingRight: '0px', position: 'relative', bottom: 0 }}>
        <Container fluid style={{ backgroundColor: 'rgb(0, 158, 224, 0.75)', display: 'flex', alignItems: 'space-between', alignContent: 'center' }}>
          <div className="footer" style={{ flexGrow: "1", textAlign: 'center' }}>
          <span><a href="https://health.maxbupa.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', fontSize: '12px', paddingRight: '10px' }}>DocsApp</a></span>
            <span><a href="https://www.docsapp.in/health/termsandprivacy" target="_blank" rel="noopener noreferrer"  style={{ color: '#fff', fontSize: '10px', paddingRight: '10px' }}>TERMS OF SERVICE AND PRIVACY POLICY</a></span>
            <span><a href="https://www.docsapp.in" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', fontSize: '10px', paddingRight: '10px' }}>Copyright © 2020 Phasorz Tech Ltd. All Rights Reserved</a></span>
            <span><a href="https://health.maxbupa.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', fontSize: '12px' }}>Max Bupa</a></span>
          </div>
        </Container>
      </Container>
    )
  }
}
